<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId" id='remove-authorized-ambassador-modal'>
    <div class="modal__content">
      <header class="modal__header">
        <h1 data-test-id="remove-ambassador-modal-header-title" class="modal-heading">
          {{ convert('ambassadorAuthorization.removeAuthorizedAmbassadorModal.modalHeading') }}</h1>
      </header>
      <h5 data-test-id="remove-ambassador-modal-ambassador-name" class="modal-paragraph">{{ ambassador?.name }}</h5>
      <p data-test-id="remove-ambassador-modal-ambassador-email" class="modal-paragraph" style="margin-bottom: 0px">{{ ambassador?.email }}</p>
      <p data-test-id="remove-ambassador-modal-ambassador-phone" class="modal-paragraph">{{ ambassador?.phone ? reformatPhone(ambassador?.phone) : '' }}</p>

      <div class="modal__actions" class="mt-3 d-flex flex-column flex-lg-row lg-justify-content-start">
        <button
          data-test-id="remove-ambassador-modal-actions-remove-button"
          class="btn btn-primary"
          type="submit"
          (click)="removeAuthorizedAmbassador(ambassador?.uuid)"
          allytmln="modalRemove"
        >
          {{ convert('ambassadorAuthorization.btnLabels.remove') }}
        </button>
        <button
          data-test-id="remove-ambassador-modal-actions-cancel-button"
          class="ms-lg-2 mt-3 mt-lg-0 btn btn-link"
          type="button"
          (click)="close()"
          allytmln="modalCancel"
        >
          {{ convert('common.btnCancel') }}
        </button>
      </div>
      <div class="modal-close-container">
        <button
          id="close_x_button"
          data-test-id="remove-ambassador-modal-header-close-button"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          data-micromodal-close
          allytmln="modalClose"
          (click)="close()"
        >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </app-modal>
</ng-container>
